import tempMeeApi from './tempMee';

/**
 * The gateway prefix organization-service is served under. The service's own
 * swagger declares `/organization-service`, which the gateway does not route.
 */
export const ORGANIZATION_SERVICE_PREFIX = '/organization-service-api';

/**
 * One authenticated request to organization-service, answering with the body.
 * The token is the raw one every request carries (see `apis/tempMee`):
 * organization-service does not take a `Bearer` prefix.
 *
 * @param {'get'|'post'|'put'|'patch'|'delete'} method
 * @param {string} path - Route under the prefix, e.g. `admin/sales-metros`
 * @param {Object} [options]
 * @param {Object} [options.params] - Query string
 * @param {Object} [options.data] - Request body
 * @returns {Promise<*>} The response body
 */
export const callOrganizationServiceApi = async (method, path, { params, data } = {}) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const response = await tempMeeApi({
    method,
    url: `${ORGANIZATION_SERVICE_PREFIX}${normalizedPath}`,
    params,
    data,
  });

  return response.data;
};
